export const getTimeStamp = () => {
  const stamp = new Date();
  const time = stamp.toLocaleTimeString("en-GB");
  const date = stamp.toLocaleDateString("en-GB");
  return `${date} ${time}`;
};

export const logger = (namespace: string, scope: string, message: string, obj?: any) => {
  console.group(`${namespace} [${scope.toUpperCase()}] [${getTimeStamp()}]`);
  if (scope === "info") {
    console.log(`${message}`);
  } else if (scope === "error") {
    console.error(`${message}`);
  } else if (scope === "warn") {
    console.warn(`${message}`);
  } else if (scope === "debug") {
    console.debug(`${message}`);
  }
  if (obj) {
    console.log(obj);
  }
  console.groupEnd();
};
